export enum Action {
  RoomUpdate = 'ROOM_UPDATE',
  StartGame = 'START_GAME',
  PlayerData = 'PLAYER_DATA',
}
